import { render } from "./users_table.vue?vue&type=template&id=387c7c21"
import script from "./users_table.vue?vue&type=script&lang=js"
export * from "./users_table.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__